export const CANVAS_SIZE = 600;
